(function() {
    'use strict';

    angular.module('montage')
        .controller('MontageUpdateController', MontageUpdateController);

    MontageUpdateController.$inject = [
        '$q',
        '$state',
        '$uibModal',
        'montageDataSrvc',
        'notificationSrvc',
        'montageMessagesConst',
        'productOptionDataSrvc',
        'formatDataSrvc',
        'plateDataSrvc',
        'productQuantityDataSrvc',
        'productOptionGroupDataSrvc',
        'montageProductDataSrvc',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'searchFilterSrvc',
        'montageOrderStatusesConst',
        'montageSrvc',
        'orderproductPermissionsConst',
        'previewSrvc',
        'checkModelPermissionsSrvc',
        'montagePermissionsConst',
        'orderSrvc',
        'filterQuerySrvc',
        'rwStatusesConst',
        'errorNotificationSrvc',
        'orderProductDataSrvc',
        'lodashService',
        'siteDataSrvc',
        'orderStatusConst'
    ];

    function MontageUpdateController(
        $q,
        $state,
        $uibModal,
        montageDataSrvc,
        notificationSrvc,
        montageMessagesConst,
        productOptionDataSrvc,
        formatDataSrvc,
        plateDataSrvc,
        productQuantityDataSrvc,
        productOptionGroupDataSrvc,
        montageProductDataSrvc,
        datatableDefaultPageSizeValueConst,
        checkSearchSrvc,
        searchFilterSrvc,
        montageOrderStatusesConst,
        montageSrvc,
        orderproductPermissionsConst,
        previewSrvc,
        checkModelPermissionsSrvc,
        montagePermissionsConst,
        orderSrvc,
        filterQuerySrvc,
        rwStatusesConst,
        errorNotificationSrvc,
        orderProductDataSrvc,
        lodashService,
        siteDataSrvc,
        orderStatusConst
    ) {
        var self = this;

        self.loadingLeft = true;
        self.loadingRight = true;

        self.isClosedDisplayed = isClosedDisplayed;
        self.isMountedDisplayed = isMountedDisplayed;
        self.isRadiatedDisplayed = isRadiatedDisplayed;
        self.isPrintedDisplayed = isPrintedDisplayed;

        self.isClosedDisabled = montageSrvc.isClosedDisabled;
        self.isMountedDisabled = montageSrvc.isMountedDisabled;
        self.isRadiatedDisabled = montageSrvc.isRadiatedDisabled;
        self.isPrintedDisabled = montageSrvc.isPrintedDisabled;

        self.setClosedMontage = montageSrvc.setClosedMontage;
        self.setMountedMontage = montageSrvc.setMountedMontage;
        self.setRadiatedMontage = montageSrvc.setRadiatedMontage;
        self.setPrintedMontage = montageSrvc.setPrintedMontage;

        self.openRealizationModal = openRealizationModal;

        self.serverErrors = {
            name: [],
            info: [],
            quantity_net: [],
            quantity_surplus: [],
            flipped: [],
            plate_quantity: [],
            extra_net: [],
            paper_option: [],
            sheet_format: [],
            plate: [],
            forced_deadline_date: [],
            motage_products: [],
            price: [],
            nonFieldErrors: []
        };

        self.montageData = {};

        self.paperOptionsList = [];
        self.sheetFormatsList = [];
        self.platesList = [];
        self.siteOptions = [];
        self.isCanDisplayMontagesSites = false;

        self.productsCols = [{
            title: 'Podgląd',
            value: 'product_file.client_file_thumbnail',
            type: 'image',
            onClick: previewFile,
            helpers: [{
                elementClass: 'preflight-status-icon',
                tooltip: 'product_file.preflight_status.message',
                typeClass: 'product_file.preflight_status.class'
            }]
        }, {
            title: 'ID zlecenia',
            value: 'pk_with_count',
            type: 'number',
            orderValue: 'pk',
            searchable: true,
            orderable: true,
            helpers: [{
                elementClass: 'fa fa-file table-helper-item',
                directTooltip: true,
                tooltip: 'Zawiera notatkę',
                typeClass: '',
                conditionProp: 'locked_info'
            }, {
                elementClass: 'fa fa-print table-helper-item',
                directTooltip: true,
                tooltip: 'Wymuszony status "W produkcji"',
                typeClass: '',
                conditionProp: 'is_locked'
            }],
            popover: {
                title: 'Szczegóły zlecenia',
                templateUrl: 'app/montage/views/montage-create/montage-product-popover.html',
                onInit: getProductChosenOptions
            }
        }, {
            title: 'Nr zamówienia',
            value: 'order_pk',
            type: 'link',
            linkTo: 'layout.order.details',
            linkParamProp: 'order_pk',
            orderValue: 'order__pk',
            searchable: true,
            orderable: true
        }, {
            title: 'ID produktu',
            value: 'product_pk',
            type: 'number',
            orderValue: 'product__pk',
            searchable: true,
            orderable: true
        }, {
            title: 'Produkt',
            value: 'product_name',
            type: 'text',
            orderValue: 'product__name',
            searchable: true,
            orderable: true
        }, {
            title: 'Nakład',
            value: 'selected_quantity',
            type: 'number',
            orderValue: 'selected_quantity__quantity',
            searchable: true,
            orderable: true
        }, {
            title: 'Format',
            value: 'product_format',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Netto',
            value: 'net_price',
            type: 'decimal',
            searchable: true,
            orderable: true
        }, {
            title: 'Waluta',
            value: 'currency',
            type: 'text'
        }, {
            title: 'Waga',
            value: 'weight',
            type: 'decimal',
            searchable: true,
            orderable: true
        }, {
            title: 'Termin realizacji',
            value: 'order_realization_date',
            type: 'date',
            orderValue: 'order__realization_date',
            searchable: true,
            orderable: true
        }];
        self.orderProductExtraActions = [{
            class: 'btn btn-primary btn-xs',
            iconClass: 'fa fa-file-pdf-o',
            onClick: function (row) {
                return orderSrvc.getOrderCard({ pk: row.order_pk })
            },
            title: 'Pobierz kartę zamówienia'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientFile,
            isDisabled: previewSrvc.isClientFileNotAvailable,
            withLoading: true,
            title: 'Plik klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getResultFile,
            isDisabled: previewSrvc.isResultFileNotAvailable,
            withLoading: true,
            title: 'Plik wyjściowy'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-user',
            onClick: previewSrvc.getClientCoverFile,
            isDisabled: previewSrvc.isClientCoverFileNotAvailable,
            displayCondition: previewSrvc.isClientCoverFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki klienta'
        }, {
            class: 'btn btn-xs',
            iconClass: 'fa fa-search',
            onClick: previewSrvc.getCoverResultFile,
            isDisabled: previewSrvc.isCoverResultFileNotAvailable,
            displayCondition: previewSrvc.isCoverResultFileNotAvailable,
            withLoading: true,
            title: 'Plik okładki wyjściowy'
        }];
        self.modelPermissions = orderproductPermissionsConst;
        self.summaryCols = {
            'selected_quantity': 'selected_quantity',
            'net_price': 'net_price_pln',
            'weight': 'weight'
        };

        self.exposingData = {
            color: {
                urgent: '#ffbebe',
                waiting_for_payment: '#ffebea',
                allegro: '#99ffff', //'#99ffff',
                external: '#f8ac59'
            },
            conditionProp: 'exposing_data',
            conditionValue: [
                'urgent',
                'waiting_for_payment',
                'allegro',
                'external'
            ]
        };

        self.pageOptsLeft = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };
        self.pageChangeLeft = pageChangeLeft;
        self.searchQueryLeft = {
            pk_with_count: null,
            order_pk: null,
            product_pk: null,
            product_name: null,
            selected_quantity: null,
            product_format: null,
            net_price: null,
            weight: null,
            order_realization_date: null,
            ordering: null
        };
        self.onSearchQueryChangeLeft = onSearchQueryChangeLeft;
        self.productsLeft = [];

        self.pageOptsRight = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };
        self.pageChangeRight = pageChangeRight;
        self.searchQueryRight = {
            pk: null,
            order_pk: null,
            product_pk: null,
            product_name: null,
            selected_quantity: null,
            product_format: null,
            net_price: null,
            weight: null,
            order_realization_date: null,
            ordering: null
        };
        self.onSearchQueryChangeRight = onSearchQueryChangeRight;
        self.productsRightFiltered = [];
        self.productsRightOriginal = [];

        self.onMoveToLeft = onMoveToLeft;
        self.onMoveToRight = onMoveToRight;

        self.orderStatusesFilter = montageOrderStatusesConst;

        self.leftFilterData = {
            order_statuses: [orderStatusConst.in_realization.value],
            format_pks: [],
            quantity_pks: [],
            paper_pks: [],
            options_pks: [],
            site_pk: null,
        };
        self.leftOptionsGroupFilterData = {};
        self.leftOptionsGroupFilter = leftOptionsGroupFilter;
        self.formatLeftFilter = [];
        self.quantityLeftFilter = [];
        self.paperLeftFilter = [];
        self.optionsGroupLeftFilter = [];
        self.leftFilter = leftFilter;

        self.rightFilterData = {
            order_statuses: [],
            format_pks: [],
            quantity_pks: [],
            paper_pks: [],
            options_pks: [],
            site_pk: null,
        };
        self.rightOptionsGroupFilterData = {};
        self.rightOptionsGroupFilter = rightOptionsGroupFilter;
        self.formatRightFilter = [];
        self.quantityRightFilter = [];
        self.paperRightFilter = [];
        self.optionsGroupRightFilter = [];
        self.rightFilter = rightFilter;

        self.rightSummary = {
            realizationDate: null,
            montageProductsCount: null,
            uniqueOrdersCount: null,
            montageProductsPriceCurrency: 'PLN',
            montagePrice: null,
            montagePriceCurrency: 'PLN'
        };
        self.updateRightSummary = updateRightSummary;

        self.updateMontage = updateMontage;
        self.cleanErrors = cleanErrors;
        self.cleanErrorsWithSummary = cleanErrorsWithSummary;

        self.onMontageProductUpdate = onMontageProductUpdate;

        self.montageDuplicating = false;
        self.hasMontageAddPermissions = hasMontageAddPermissions;
        self.duplicateMontage = duplicateMontage;

        self.rwStatusOptions = rwStatusesConst;
        self.rwNoteRequired = false;

        activate();

        function activate() {
            self.isCanDisplayMontagesSites = canDisplayMontagesSites();
            self.leftFilterData = filterQuerySrvc.initializeFilterData(self.leftFilterData, ':left');
            if (!self.leftFilterData.order_statuses.length) {
                self.leftFilterData.order_statuses = [orderStatusConst.in_realization.value];
            }
            self.pageOptsLeft = filterQuerySrvc.initializePageOpts(self.pageOptsLeft, ':left');
            self.searchQueryLeft = filterQuerySrvc.initializeSearchQuery(self.searchQueryLeft, ':left');

            self.rightFilterData = filterQuerySrvc.initializeFilterData(self.rightFilterData, ':right');
            self.pageOptsRight = filterQuerySrvc.initializePageOpts(self.pageOptsRight, ':right');
            self.searchQueryRight = filterQuerySrvc.initializeSearchQuery(self.searchQueryRight, ':right');

            $q.all([getMontage()])
                .then(function(response) {
                    getSiteOptions(leftOptionsGroupFilter);
                    getMontageProductsRightOriginal().then(function() {
                        rightOptionsGroupFilter();
                    });
                    getPaperOptionsList();
                    getSheetFormatsList();
                    getPlatesList();
                    updateRightSummary();
                    activateFilter();
                });
        }

        function openRealizationModal(montagePk) {
            $uibModal.open({
                templateUrl: 'app/montage/views/montage-realization/montage-realization.html',
                controller: 'MontageRealizationController',
                controllerAs: 'ctrl',
                size: 'xl',
                windowClass: 'production-cube-realization',
                resolve: {
                    montagePk: function() {
                        return montagePk;
                    }
                }
                }).closed.then(function() {
                    return montageDataSrvc.get({
                        pk: $state.params.pk
                    }).$promise.then(function(response) {
                        self.montageData.closed = response.closed;
                        self.montageData.radiated = response.radiated;
                        self.montageData.printed = response.printed;
                        self.montageData.mounted = response.mounted;
                    });
                }
            );
        }

        function activateFilter() {
            return $q.all([getMontageProductLeftFilterFormat(), getMontageProductLeftFilterQuantity(),
                getMontageProductLeftFilterPaper(), getMontageProductLeftFilterOptionsGroup(),
                getMontageProductRightFilterFormat(), getMontageProductRightFilterQuantity(),
                getMontageProductRightFilterPaper(), getMontageProductRightFilterOptionsGroup()
            ]);
        }

        function getMontage() {
            return montageDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function(response) {
                self.montageData = response;
                self.rwNoteRequired = self.montageData.rw_status === 'manual_issued';

                delete self.montageData.date_modified;
                delete self.montageData.date_added;
                return response;
            });
        }

        function getPaperOptionsList(montagePk) {
            productOptionDataSrvc.montagePaperOptions()
                .$promise.then(function(response) {
                    self.paperOptionsList = response;
                });
        }

        function getSheetFormatsList() {
            formatDataSrvc.montageFormat()
                .$promise.then(function(response) {
                    self.sheetFormatsList = response;
                });
        }

        function getPlatesList() {
            plateDataSrvc.montagePlates()
                .$promise.then(function(response) {
                    self.platesList = response;
                });
        }

        function getMontageProductsLeft(filterObj) {
            self.loadingLeft = true;

            if (!filterObj) {
                filterObj = {
                    exclude_pks: getProductsRightOriginalPks(),

                    order_statuses: self.leftFilterData.order_statuses,
                    format_pks: self.leftFilterData.format_pks,
                    quantity_pks: self.leftFilterData.quantity_pks,
                    paper_pks: self.leftFilterData.paper_pks,
                    options_pks: self.leftFilterData.options_pks,
                    site_pk: self.leftFilterData.site_pk,

                    page: self.pageOptsLeft.page,
                    page_size: self.pageOptsLeft.pageSize,
                    id: self.searchQueryLeft.pk_with_count,
                    order_pk: self.searchQueryLeft.order_pk,
                    product_pk: self.searchQueryLeft.product_pk,
                    product_name: self.searchQueryLeft.product_name,
                    selected_quantity: self.searchQueryLeft.selected_quantity,
                    product_format: self.searchQueryLeft.product_format,
                    net_price: self.searchQueryLeft.net_price,
                    weight: self.searchQueryLeft.weight,
                    order_realization_date: searchFilterSrvc.getDateValue(self.searchQueryLeft.order_realization_date),
                    ordering: self.searchQueryLeft.ordering
                };
            }

            return montageProductDataSrvc.leftTable(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.productsLeft = response.results;
                        self.pageOptsLeft.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getMontageProductsLeft);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loadingLeft = false;
                        return response;
                    }
                );
        }

        function pageChangeLeft() {
            filterQuerySrvc.updatePageOpts(self.pageOptsLeft, ':left');
            return getMontageProductsLeft();
        }

        function onSearchQueryChangeLeft() {
            filterQuerySrvc.updateSearchQuery(self.searchQueryLeft, ':left');
            return getMontageProductsLeft();
        }

        function getMontageProductsRightOriginal() {
            return $q(function(resolve, reject) {
                self.productsRightOriginal = self.montageData.montage_products;
                resolve();
            });
        }

        function getMontageProductsRightFiltered(filterObj) {
            self.loadingRight = true;

            if (!filterObj) {
                filterObj = {
                    pks: getProductsRightOriginalPks(),

                    order_statuses: self.rightFilterData.order_statuses,
                    format_pks: self.rightFilterData.format_pks,
                    quantity_pks: self.rightFilterData.quantity_pks,
                    paper_pks: self.rightFilterData.paper_pks,
                    options_pks: self.rightFilterData.options_pks,
                    site_pk: self.rightFilterData.site_pk,

                    page: self.pageOptsRight.page,
                    page_size: self.pageOptsRight.pageSize,
                    id: self.searchQueryRight.pk_with_count,
                    order_pk: self.searchQueryRight.order_pk,
                    product_pk: self.searchQueryLeft.product_pk,
                    product_name: self.searchQueryRight.product_name,
                    selected_quantity: self.searchQueryRight.selected_quantity,
                    product_format: self.searchQueryRight.product_format,
                    net_price: self.searchQueryRight.net_price,
                    weight: self.searchQueryRight.weight,
                    order_realization_date: searchFilterSrvc.getDateValue(self.searchQueryRight.order_realization_date),
                    ordering: self.searchQueryRight.ordering
                };
            }

            return montageProductDataSrvc.rightTable(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.productsRightFiltered = response.results;
                        self.pageOptsRight.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getMontageProductsRightFiltered);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loadingRight = false;
                        return response;
                    }
                );
        }

        function pageChangeRight() {
            filterQuerySrvc.updatePageOpts(self.pageOptsRight, ':right');
            return getMontageProductsRightFiltered();
        }

        function onSearchQueryChangeRight() {
            filterQuerySrvc.updateSearchQuery(self.searchQueryRight, ':right');
            return getMontageProductsRightFiltered();
        }

        /**
         * Remove objects from right table.
         */
        function onMoveToLeft(arr) {
            for (var i = 0; i < arr.length; ++i) {
                for (var j = 0; j < self.productsRightOriginal.length; ++j) {
                    if (self.productsRightOriginal[j].pk === arr[i].pk) {
                        self.productsRightOriginal.splice(j, 1);
                        break;
                    }
                }
            }
            self.pageOptsLeft.count += arr.length;
            self.pageOptsRight.count -= arr.length;

            self.loadingRight = true;
            updateRightSummary();
            updateMontagePrice();
            activateFilter().then(
                function (response) {
                    checkRightOptionsGroupFilterData();
                    rightOptionsGroupFilter()
                },
                function (response) {
                    self.loadingRight = false;
                }
            );
        }

        /**
         * Add objects to right table.
         */
        function onMoveToRight(arr) {
            for (var i = 0; i < arr.length; ++i) {
                self.productsRightOriginal.push(arr[i]);
            }
            self.pageOptsLeft.count -= arr.length;
            self.pageOptsRight.count += arr.length;

            self.loadingLeft = true;
            updateRightSummary();
            updateMontagePrice();
            activateFilter().then(
                function (response) {
                    checkLeftOptionsGroupFilterData();
                    leftOptionsGroupFilter();
                },
                function (response) {
                    self.loadingLeft = false;
                }
            );
        }

        function getProductsRightOriginalPks() {
            return self.productsRightOriginal.map(function(item) {
                return item.pk;
            });
        }

        function leftFilter() {
            filterQuerySrvc.updateFilterData(self.leftFilterData, ':left');
            return getMontageProductsLeft();
        }

        function leftOptionsGroupFilter() {
            var options_pks = [];
            for (var key in self.leftOptionsGroupFilterData) {
                options_pks.push.apply(options_pks, self.leftOptionsGroupFilterData[key]);
            }
            self.leftFilterData.options_pks = options_pks;

            return getMontageProductsLeft();
        }

        function getMontageProductLeftFilterFormat() {
            return formatDataSrvc.montageProductFilterFormat({
                left: true,
                exclude_pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.formatLeftFilter = response;
                return response;
            });
        }

        function getMontageProductLeftFilterQuantity() {
            return productQuantityDataSrvc.montageProductFilterQuantity({
                left: true,
                exclude_pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.quantityLeftFilter = response;
                return response;
            });
        }

        function getMontageProductLeftFilterPaper() {
            return productOptionDataSrvc.montageProductFilterPaper({
                left: true,
                exclude_pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.paperLeftFilter = response;
                return response;
            });
        }

        function getMontageProductLeftFilterOptionsGroup() {
            return productOptionGroupDataSrvc.montageProductFilterOptionsGroup({
                left: true,
                exclude_pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.optionsGroupLeftFilter = response;
                return response;
            });
        }

        function rightFilter() {
            filterQuerySrvc.updateFilterData(self.rightFilterData, ':right');
            return getMontageProductsRightFiltered();
        }

        function rightOptionsGroupFilter() {
            var options_pks = [];
            for (var key in self.rightOptionsGroupFilterData) {
                options_pks.push.apply(options_pks, self.rightOptionsGroupFilterData[key]);
            }
            self.rightFilterData.options_pks = options_pks;

            return getMontageProductsRightFiltered();
        }

        function getMontageProductRightFilterFormat() {
            return formatDataSrvc.montageProductFilterFormat({
                right: true,
                pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.formatRightFilter = response;
                return response;
            });
        }

        function getMontageProductRightFilterQuantity() {
            return productQuantityDataSrvc.montageProductFilterQuantity({
                right: true,
                pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.quantityRightFilter = response;
                return response;
            });
        }

        function getMontageProductRightFilterPaper() {
            return productOptionDataSrvc.montageProductFilterPaper({
                right: true,
                pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.paperRightFilter = response;
                return response;
            });
        }

        function getMontageProductRightFilterOptionsGroup() {
            return productOptionGroupDataSrvc.montageProductFilterOptionsGroup({
                right: true,
                pks: getProductsRightOriginalPks(),
            }).$promise.then(function(response) {
                self.optionsGroupRightFilter = response;
                return response;
            });
        }

        function updateRightSummary() {
            self.rightSummary.realizationDate = montageSrvc.getRealizationDate(
                self.montageData, self.productsRightOriginal);

            self.rightSummary.montageProductsCount = montageSrvc.getMontageProductsCount(
                self.productsRightOriginal);

            self.rightSummary.uniqueOrdersCount = montageSrvc.getUniqueOrdersCount(
                self.productsRightOriginal);

            self.rightSummary.montageProductsPrice = montageSrvc.getMontageProductsPrice(
                self.productsRightOriginal, 'net_price_pln');

            var paperOption = self.paperOptionsList.find(function(item) {
                return item.pk === self.montageData.paper_option;
            });
            var sheetFormat = self.sheetFormatsList.find(function(item) {
                return item.pk === self.montageData.sheet_format;
            });
            var plate = self.platesList.find(function(item) {
                return item.readable_plate === self.montageData.plate;
            });
            self.rightSummary.montagePrice = montageSrvc.getMontagePrice(
                self.montageData, paperOption, sheetFormat, plate);
        }

        function updateMontagePrice() {
            self.montageData.price = Math.round(self.rightSummary.montagePrice * 100) / 100;
        }

        function updateMontage() {
            self.montageData.montage_products = getProductsRightOriginalPks();
            updateMontagePrice();

            montageDataSrvc.update({
                pk: self.montageData.pk
            }, self.montageData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", montageMessagesConst.update);
                    $state.go('layout.montage.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
            self.rwNoteRequired = self.montageData.rw_status === 'manual_issued';
        }

        function cleanErrorsWithSummary(key) {
            updateRightSummary();
            updateMontagePrice();
            self.cleanErrors(key);
        }

        function onMontageProductUpdate(row) {
            $uibModal.open({
                templateUrl: 'app/montage/views/montage-product-update/montage-product-update.html',
                controller: 'MontageProductUpdateController',
                controllerAs: 'ctrl',
                size: 'lg',
                resolve: {
                    montageProduct: function() {
                        return row;
                    }
                }
            });
        }

        // Duplicating creates a new montage, so it needs the add permission.
        function hasMontageAddPermissions() {
            return !checkModelPermissionsSrvc.isDenied(montagePermissionsConst.add);
        }

        function duplicateMontage(montage) {
            montageSrvc.duplicate(
                montage,
                function() {
                    self.montageDuplicating = true;
                },
                function() {
                    self.montageDuplicating = false;
                }
            );
        }

        function isClosedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_closed_montage_permission);
        }

        function isMountedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_mounted_montage_permission);
        }

        function isRadiatedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_radiated_montage_permission);
        }

        function isPrintedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_printed_montage_permission);
        }
        
        function previewFile(orderProduct) {
            orderProductDataSrvc.getFileData({
                pk: orderProduct.pk
            }).$promise.then(
                function (response) {
                    angular.extend(orderProduct, response.toJSON());
                    previewSrvc.previewOrderFile(orderProduct);
                }
            )
        }

        function getProductChosenOptions($event, orderProduct) {
            $event.stopPropagation();

            if (!orderProduct.hasOwnProperty('chosen_options')) {
                return orderProductDataSrvc.getChosenOptions({
                    pk: orderProduct.pk
                }).$promise.then(
                    function (response) {
                        angular.extend(orderProduct, response.toJSON());
                        return response;
                    }
                )
            } else {
                return true;
            }
        }

        function checkLeftOptionsGroupFilterData() {
            for (var key in self.leftOptionsGroupFilterData) {
                if (self.leftOptionsGroupFilterData.hasOwnProperty(key)) {
                    if (!lodashService.find(self.optionsGroupLeftFilter, function (item) {
                        return item.pk === key;
                    })) {
                        delete self.leftOptionsGroupFilterData[key];
                    }
                }
            }
        }

        function checkRightOptionsGroupFilterData() {
            for (var key in self.rightOptionsGroupFilterData) {
                if (self.rightOptionsGroupFilterData.hasOwnProperty(key)) {
                    if (!lodashService.find(self.optionsGroupRightFilter, function (item) {
                        return item.pk === key;
                    })) {
                        delete self.rightOptionsGroupFilterData[key];
                    }
                }
            }
        }

        function getSiteOptions(callback) {
            if (self.isCanDisplayMontagesSites) {
                return siteDataSrvc.getFieldOpts().$promise.then(
                    function (response) {
                        self.siteOptions = response.results;
                        if (callback !== null) {
                            callback();
                        }
                    }
                );
            } else {
                callback();
            }
        }

        function canDisplayMontagesSites() {
            return !checkModelPermissionsSrvc.isDenied(montagePermissionsConst.view_montage_from_sites_permission);
        }
    }
})();
